import { render } from "./ProductsInSale.vue?vue&type=template&id=e41ac166&scoped=true"
import script from "./ProductsInSale.vue?vue&type=script&lang=js"
export * from "./ProductsInSale.vue?vue&type=script&lang=js"

import "./ProductsInSale.vue?vue&type=style&index=0&id=e41ac166&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e41ac166"]])

export default __exports__